import { useCallback, useState } from 'react';
import axios from 'axios';

export function useNewsletterQnA({
                                     activeAccount,
                                     apiRootUrl,
                                     getAccessToken,
                                     today,
                                 }) {

    // Newsletter Q&A form fields and response state
    const [qnaQuestion, setQnaQuestion] = useState('');
    const [qnaFromYear, setQnaFromYear] = useState(today.getFullYear() - 1);
    const [qnaFromMonth, setQnaFromMonth] = useState(today.getMonth() + 1);
    const [qnaThruYear, setQnaThruYear] = useState(today.getFullYear());
    const [qnaThruMonth, setQnaThruMonth] = useState(today.getMonth() + 1);
    const [qnaAnswer, setQnaAnswer] = useState('');
    const [qnaLoading, setQnaLoading] = useState(false);
    const [qnaError, setQnaError] = useState('');

    // Submit user question to the newsletter RAG endpoint
    const handleNewsletterQnASubmit = useCallback(async (event) => {
        event.preventDefault();

        if (!qnaQuestion.trim()) {
            setQnaError('Please enter a question.');
            return;
        }

        if (!activeAccount) {
            setQnaError('Please sign in before asking a question.');
            return;
        }

        try {
            setQnaLoading(true);
            setQnaError('');
            setQnaAnswer('');

            const accessToken = await getAccessToken();

            const response = await axios.post(`${apiRootUrl}/v1/newsletter-qna`, {
                question: qnaQuestion.trim(),
                fromYear: qnaFromYear,
                fromMonth: qnaFromMonth,
                thruYear: qnaThruYear,
                thruMonth: qnaThruMonth,
                topK: 5,
            }, {
                headers: { Authorization: `Bearer ${accessToken}` },
            });

            setQnaAnswer(response?.data?.answer || '');
        } catch (err) {
            console.error('Error asking newsletter question', err);

            setQnaError(
                err?.response?.data?.detail ||
                err?.message ||
                'Unable to get an answer right now.'
            );
        } finally {
            setQnaLoading(false);
        }
    }, [
        activeAccount,
        apiRootUrl,
        getAccessToken,
        qnaFromMonth,
        qnaFromYear,
        qnaQuestion,
        qnaThruMonth,
        qnaThruYear,
    ]);

    return {
        qnaQuestion,
        setQnaQuestion,
        qnaFromYear,
        setQnaFromYear,
        qnaFromMonth,
        setQnaFromMonth,
        qnaThruYear,
        setQnaThruYear,
        qnaThruMonth,
        setQnaThruMonth,
        qnaAnswer,
        qnaLoading,
        qnaError,
        handleNewsletterQnASubmit,
    };
}